import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProtocolSection } from './components/ProtocolSection';
import { DifferenceSection } from './components/DifferenceSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { AudienceSection } from './components/AudienceSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window.fbq === 'function') return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '884777681203338');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-cream-50 text-stone-800 antialiased overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmpathySection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <ProtocolSection data-id="element-5" />
      <DifferenceSection data-id="element-6" />
      <WhatsInsideSection data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}